import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'categories-load_page_section-timing';
/**
 * Used to track loading times of various sections of a category page.

Parameters:
1. Category navigation path
2. Page section name
*/ export function trackCategoriesLoadPageSectionTiming(categoryPath, sectionName2, manualOverrides) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        manualOverrides: manualOverrides,
        parameters: {
            categoryPath: categoryPath,
            sectionName2: sectionName2
        }
    });
}
/**
 * Trace for event: categories-load_page_section-timing
 */ export function trackCategoriesLoadPageSectionTimingTraceApiRequestEnd(sourceEventMarker, manualOverrides) {
    trackClientEvent({
        eventKey: 'categories-load_page_section-timing-trace-api_request_end',
        realTimeTracking: false,
        manualOverrides: manualOverrides,
        sourceEventKey: 'categories-load_page_section-timing',
        sourceEventMarker: sourceEventMarker
    });
}
/**
 * Trace for event: categories-load_page_section-timing
 */ export function trackCategoriesLoadPageSectionTimingTraceApiRequestStart(sourceEventMarker, manualOverrides) {
    trackClientEvent({
        eventKey: 'categories-load_page_section-timing-trace-api_request_start',
        realTimeTracking: false,
        manualOverrides: manualOverrides,
        sourceEventKey: 'categories-load_page_section-timing',
        sourceEventMarker: sourceEventMarker
    });
}
/**
 * Trace for event: categories-load_page_section-timing
 */ export function trackCategoriesLoadPageSectionTimingTraceRendered(sourceEventMarker, manualOverrides) {
    trackClientEvent({
        eventKey: 'categories-load_page_section-timing-trace-rendered',
        realTimeTracking: false,
        manualOverrides: manualOverrides,
        sourceEventKey: 'categories-load_page_section-timing',
        sourceEventMarker: sourceEventMarker
    });
}
